export function resize(type, initialWidth, initialHeight, constrainingWidth, constrainingHeight) {
  const initialRatio = initialWidth / initialHeight;
  const constrainingRatio = constrainingWidth / constrainingHeight;
  const fitWidth =
    type === 'contain' ? initialRatio > constrainingRatio : initialRatio < constrainingRatio;
  let x,
    y,
    width,
    height,
    scale = 1;
  if (fitWidth) {
    width = constrainingWidth;
    height = constrainingWidth / initialRatio;
  } else {
    width = constrainingHeight * initialRatio;
    height = constrainingHeight;
    scale = initialRatio / constrainingRatio;
  }
  x = (constrainingWidth - width) / 2;
  y = (constrainingHeight - height) / 2;
  return { x, y, width, height, scale };
}

const isInBound = (overlayDimension, constrainingDimension, offset) =>
  overlayDimension - Math.abs(offset) >= constrainingDimension;

const positionToOffset = (position, bound) => (0.5 - position) * 2 * bound;

export function isCovering(innerBox, outerBox) {
  const {
    bounds: { width, height },
    scale,
    position,
  } = innerBox;
  const {
    bounds: { width: constrainingWidth, height: constrainingHeight },
  } = outerBox;
  const x = positionToOffset(position[0], constrainingWidth);
  const y = positionToOffset(position[1], constrainingHeight);
  return (
    isInBound(width * scale, constrainingWidth, x) &&
    isInBound(height * scale, constrainingHeight, y)
  );
}

export const cover = resize.bind(null, 'cover');

export const contain = resize.bind(null, 'contain');
